import { forwardRef } from 'react'
import type { CrmIntegrationMessageDisplay } from '../../types/crm-integration-message.types'
import CrmIntegrationTextChatMessageListItem from './CrmIntegrationTextChatMessageListItem'
import classes from '../../styles/crmIntegrationChat.module.css'

type CrmIntegrationTextChatMessageListProps = {
  messages: CrmIntegrationMessageDisplay[]
  onRetrySend: (clientId: string) => void
  onVideoPlaybackError?: () => void
  onVoicePlaybackError?: () => void
}

const CrmIntegrationTextChatMessageList = forwardRef<
  HTMLUListElement,
  CrmIntegrationTextChatMessageListProps
>(({ messages, onRetrySend, onVideoPlaybackError, onVoicePlaybackError }, ref) => (
  <ul ref={ref} className={classes.messagesList}>
    {messages.map((message) => (
      <CrmIntegrationTextChatMessageListItem
        key={message.clientId ?? String(message.id)}
        message={message}
        onRetrySend={onRetrySend}
        onVideoPlaybackError={onVideoPlaybackError}
        onVoicePlaybackError={onVoicePlaybackError}
      />
    ))}
  </ul>
))

CrmIntegrationTextChatMessageList.displayName = 'CrmIntegrationTextChatMessageList'

export default CrmIntegrationTextChatMessageList
